var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "currentColor", fillRule: "evenodd" },
            React.createElement("path", { d: "M33 30a1 1 0 01.993.883L34 31v2.5a1.5 1.5 0 01-1.356 1.493L32.5 35h-17a1.5 1.5 0 01-1.493-1.356L14 33.5V31a1 1 0 011.993-.117L16 31v2h16v-2a1 1 0 01.883-.993L33 30z", fillRule: "nonzero" }),
            React.createElement("path", { d: "M20.618 23.935h1.385v-9.23C22.003 13.764 23.12 13 24 13c.881 0 2.004.764 2.004 1.705v9.23h1.378c1.258 0 2.224-.147 2.521.527.337.757-.215 1.12-1.395 2.385l-3.38 3.618a1.523 1.523 0 01-2.255 0l-3.38-3.618c-1.187-1.274-1.73-1.668-1.394-2.393.298-.647 1.271-.519 2.52-.519z" }))));
});
